module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('md-card', {
    staticClass: "ql-cue",
    style: (_vm.style()),
    attrs: {
      "id": _vm.cue.id
    }
  }, [_c('project-cues-cue-header', {
    attrs: {
      "expanded": _vm.expanded,
      "cue": _vm.cue,
      "layer": _vm.layer,
      "layers": _vm.editableLayers,
      "locked": _vm.locked,
      "editable": _vm.editable,
      "color": _vm.color
    },
    on: {
      "toggle": _vm.toggle,
      "cueUpdated": _vm.updatedCue
    }
  }), _vm._v(" "), _c('project-cues-cue-body', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    attrs: {
      "cue": _vm.cue,
      "locked": _vm.locked,
      "editable": _vm.editable,
      "color": _vm.color
    },
    on: {
      "cueUpdated": _vm.updatedCue,
      "destroy": _vm.destroy
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c87ba5ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/cues/cue.vue
// module id = 679
// module chunks = 2